import { Link } from "wouter";
import { useT } from "../i18n/index.js";

export default function NotFound() {
  const t = useT();
  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-50 flex items-center justify-center p-6">
      <div className="text-center">
        <h1 className="text-6xl font-semibold mb-2 tracking-tight">404</h1>
        <p className="text-neutral-400 mb-6">{t("notFound.title")}</p>
        <Link href="/" className="text-lime underline">
          {t("notFound.backHome")}
        </Link>
      </div>
    </div>
  );
}
